import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IPriceRange } from "redmond";
import { Dispatch } from "@reduxjs/toolkit";
import { RouterProps } from "react-router-dom";

import { actions } from "../../actions";
import { IStoreState } from "../../../../reducers/types";
import {
  getHotelAvailabilityMinMaxPriceRange,
  getIsFilteredHotelAvailabilityLodgingsEmptyAndDoneSearching,
  getIsUnfilteredHotelAvailabilityLodgingsEmpty,
  initialFilterState,
} from "../../reducer/index";
import { AvailabilityNoResults } from "./component";
import { setOpenDatesModal } from "../../../search/actions/actions";

interface IStateProps {
  minMaxPriceRange: IPriceRange | null;
  unfilteredLodgingsEmpty: boolean;

  isFilteredHotelAvailabilityLodgingsEmpty: boolean;
}

const mapStateToProps = (state: IStoreState): IStateProps => {
  return {
    minMaxPriceRange: getHotelAvailabilityMinMaxPriceRange(state),
    unfilteredLodgingsEmpty:
      getIsUnfilteredHotelAvailabilityLodgingsEmpty(state),

    isFilteredHotelAvailabilityLodgingsEmpty:
      getIsFilteredHotelAvailabilityLodgingsEmptyAndDoneSearching(state),
  };
};

interface IDispatchProps {
  resetFilters: () => void;
  setOpenDatesModal: (openDatesModal: boolean) => void;
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => {
  return {
    resetFilters: () => {
      dispatch(actions.setAmenitiesFilter(initialFilterState.amenities));
      dispatch(actions.setStarRatingsFilter(initialFilterState.starRatings));
      dispatch(actions.setHotelNameFilter(initialFilterState.hotelName));
      dispatch(actions.setFreeCancelFilter(initialFilterState.freeCancel));

      dispatch(actions.setMaxPriceFilter(initialFilterState.maxPrice));

      dispatch(actions.setPolicyFilter(initialFilterState.isInPolicy));

      dispatch(actions.setMealPlanFilter(initialFilterState.mealPlanTypes));

      dispatch(
        actions.setDiscountFilter(initialFilterState.onlyDiscountedProperties)
      );
    },
    setOpenDatesModal: (openDatesModal: boolean) =>
      dispatch(setOpenDatesModal(openDatesModal)),
  };
};

interface OwnProps extends RouterProps {}

const mergeProps = (
  stateProps: IStateProps,
  dispatchProps: IDispatchProps,
  ownProps: OwnProps
) => {
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    resetFilters: () => dispatchProps.resetFilters(),
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type AvailabilityNoResultsConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedAvailabilityNoResults = withRouter(
  connector(AvailabilityNoResults)
);
